import { render, staticRenderFns } from "./KnFormTuitionAllocation.vue?vue&type=template&id=c05cb618"
import script from "./KnFormTuitionAllocation.js?vue&type=script&lang=js&external"
export * from "./KnFormTuitionAllocation.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports